<span mat-dialog-title>{{ 'ACCOUNT.CHANGE_EMAIL.DIALOG.TITLE' | translate }}</span>
<div mat-dialog-content>
  <p>{{ 'ACCOUNT.CHANGE_EMAIL.DIALOG.INFO' | translate }}</p>
</div>
<ng-container *ngIf="formState$ | async as formState">
  <mat-form-field appearance="fill" class="password-input">
    <mat-label>{{ 'ACCOUNT.CHANGE_EMAIL.DIALOG.PASSWORD' | translate }}</mat-label>
    <input matInput type="password" [ngrxFormControlState]="formState"
  /></mat-form-field>
</ng-container>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close class="dark-plain-button">{{ 'GENERAL.CANCEL' | translate }}</button>
  <!--todo: implement logic-->
  <button mat-flat-button mat-dialog-close color="primary">{{ 'GENERAL.CONFIRM' | translate }}</button>
</div>
